import '../styles/WhyChoose.css';

function CertifiedIcon() {
  return (
    <svg className="WhyChoose-CertifiedIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="9" r="5" />
      <path d="m9.6 9 1.6 1.6 3.3-3.3M9.5 14 8 20l4-2 4 2-1.5-6" />
    </svg>
  );
}

function WarrantyIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 3.5 19 6v5.2c0 4.3-2.9 7.5-7 9.3-4.1-1.8-7-5-7-9.3V6l7-2.5Z" />
      <path d="m8.8 11.6 2.1 2.1 4.3-4.3" />
    </svg>
  );
}

const features = [
  { icon: '✓', title: 'Licensed & Insured', description: 'Fully licensed and insured for your peace of mind' },
  { icon: '◆', title: 'Certified Technicians', description: 'Experienced specialists who respect your home' },
  { icon: '★', title: '5-Star Service', description: 'Consistently rated five stars by our customers' },
  { icon: '◇', title: 'Quality Warranty', description: 'Comprehensive warranty protection on installations' },
];

const testimonials = [
  {
    quote: 'Exceptional service from start to finish. The team was professional, punctual, and the installation was flawless.',
    author: 'Sarah M.',
    location: 'Sacramento',
  },
  {
    quote: 'Emergency repair on a Sunday, and they came out within two hours. Outstanding customer service and fair pricing.',
    author: 'Mike R.',
    location: 'Daly City',
  },
];

export default function WhyChoose() {
  return (
    <section id="WhyChoose-Container" className="WhyChoose-Section">
      <div className="WhyChoose-Container">
        <div className="WhyChoose-Left">
          <p className="Section-Eyebrow Section-Eyebrow--light">WHY GOLDEN STATE</p>
          <h2 className="WhyChoose-Title">Craftsmanship you can count on.</h2>
          <p className="WhyChoose-Subtitle">
            For over 20 years, we’ve been California’s trusted garage door specialists. Our commitment to quality, reliability, and honest service guides every project.
          </p>
          <div className="WhyChoose-Features">
            {features.map((feature) => (
              <div className="WhyChoose-Feature" key={feature.title}>
                <span className="WhyChoose-Icon" aria-hidden="true">
                  {feature.title === 'Certified Technicians' ? <CertifiedIcon /> : feature.title === 'Quality Warranty' ? <WarrantyIcon /> : feature.icon}
                </span>
                <div>
                  <div className="WhyChoose-FeatureTitle">{feature.title}</div>
                  <div className="WhyChoose-FeatureDesc">{feature.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="WhyChoose-Right">
          <p className="WhyChoose-QuoteMark" aria-hidden="true">“</p>
          <h3 className="WhyChoose-TestimonialsTitle">What our customers say</h3>
          {testimonials.map((testimonial) => (
            <article className="WhyChoose-Testimonial" key={testimonial.author}>
              <div className="WhyChoose-Stars" aria-label="5 out of 5 stars">★★★★★</div>
              <p className="WhyChoose-TestimonialText">“{testimonial.quote}”</p>
              <p className="WhyChoose-TestimonialAuthor">
                {testimonial.author} <span>{testimonial.location}</span>
              </p>
            </article>
          ))}
          <a
            className="WhyChoose-Button"
            href="https://www.yelp.com/biz/golden-state-garage-doors-santa-clara-2"
            target="_blank"
            rel="noreferrer"
          >
            Read more reviews <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}
